import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { VolvoApiService } from '../../../../services/volvo-api.service';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-find-participating-dealer',
  templateUrl: './find-participating-dealer.component.html',
  styleUrls: ['./find-participating-dealer.component.scss']
})
export class FindParticipatingDealerComponent implements OnInit {

  @Input() Guid: string;
  @Input() localStrings: Array<any>;
  dealers$: Observable<any>;

  @Output() requestInfo = new EventEmitter<string>();

  constructor(
    private volvoApi: VolvoApiService,
    private dialogRef: MatDialogRef<FindParticipatingDealerComponent>
  ) { }

  ngOnInit() {
    this.dealers$ = this.volvoApi.getAvailablePartners(this.Guid);
  }

  requestInfofromDealer(Code?: string) {
    this.requestInfo.emit(Code);
  }

}
